<div class="modal-header">
  <h3 class="modal-title">Adresse ändern</h3>
</div>

<div class="modal-body">
  <div class="whitelist contactlist">
    @for (value of addresses; track value) {
      <div class="whitelist-item click" (click)="select(value)"
        [ngClass]="{selected: value.id === selected}">
        <h4>{{ value.name }}</h4>
        @if (value.company_name) {
          <p>{{ value.company_name }} </p>
        }
        @if (value.company_department) {
          <p>{{ value.company_department }}</p>
        }
        <p>{{ value.street }}</p>
        <p>{{ value.zip }} {{ value.city }}</p>
        <p>{{ value.country }}</p>
      </div>
    }
  </div>
</div>

<div class="modal-footer">
</div>
